import { useEffect } from "react"
import { FormProvider, useFormSistema } from "../../../hooks/useForm"
import { useSistema } from "../../../hooks/useSistema"
import { Row } from "../../../componentes/layout/template/Row"
import { Grid } from "../../../componentes/layout/template/Grid"
import { CampoSelectPesquisa } from "../../../componentes/layout/campos/CampoSelectPesquisa"
import { Botao } from "../../../componentes/layout/botoes/Botao"


export function ModalTrocarEmpresa(){
    return (
        <FormProvider id="modalTrocarEmpresa" formLimpo>
            <ModalTrocarEmpresaDados />
        </FormProvider>
    )
}

function ModalTrocarEmpresaDados(){
    const { usuario, trocarEmpresa } = useSistema()
    const { carregaForm, campos } = useFormSistema()

    function handleTrocarEmpresa(){
        if (campos.empresa !== usuario.empresa){
            trocarEmpresa(campos.empresa)
        }
    }

    useEffect(() => {
        carregaForm({
            empresa: usuario.empresa
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Row>
            <Grid cols="2" classe="text-right"><strong>Empresa:</strong></Grid>
            <Grid cols="8">
                <CampoSelectPesquisa nome="empresa" id="empresa"
                    placeholder="Empresa"
                    obrigatorio 
                    servico={'empresas/select|{}'}
                />
            </Grid>
            <Grid cols="2" classe="text-center">
                <Botao
                    submit
                    preencher
                    fecharModal
                    cor="primary"
                    icone="check"
                    label="Trocar"
                    onClick={handleTrocarEmpresa}
                />
            </Grid>
        </Row>
    )
}